export default "__VITE_ASSET__ClPgYSrG__"